import { Component, EventEmitter, Input, Output } from '@angular/core';
import { SubscriptionCategory } from '@models/subscription.model';

@Component({
	selector: 'subscription-period-change',
	template: require('./subscription-period-change.html'),
	styles: [require('./subscription-period-change.scss')]
})
export class SubscriptionPeriodChangeComponent {
	@Input() categoryNames: SubscriptionCategory;
	@Input() activeIndex = 0;
	@Output()
	periodChangeEmitter: EventEmitter<[string, number]> = new EventEmitter();

	constructor() {}
	emitPeriodChange(period: string, i: number): void {
		this.periodChangeEmitter.next([period, i]);
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=os2z8rc99lf!./web/modern/components/subscription/modals/subscription-modal/subscription-period-change/subscription-period-change.ts